import { render } from "./HeaderStepBlockMobile.vue?vue&type=template&id=5b50d674"
import script from "./HeaderStepBlockMobile.vue?vue&type=script&lang=js"
export * from "./HeaderStepBlockMobile.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__